import React from 'react';

const VrIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 120 120"
      role="graphics-symbol"
      aria-label="360 degree video"
    >
      <g data-name="vr-icon">
        <rect data-name="vr-icon-stage" width="120" height="120" fill="none" />
        <path
          data-name="vr-icon-text"
          d="M42.08,53.7c0,4.56-3.88,7.8-10.08,7.8-4.72,0-8.24-1.92-10.08-4.32l2.56-3.08a9.87,9.87,0,0,0,7.36,3.24c3.52,0,5.56-1.64,5.56-4.08,0-2.64-2.08-3.8-5.92-3.8-1.12,0-2.64,0-3,.08V45.3c.44,0,2,0,3,0,3.16,0,5.52-1.08,5.52-3.52s-2.44-3.72-5.4-3.72a9.25,9.25,0,0,0-6.92,3l-2.4-2.92A12.37,12.37,0,0,1,32,33.94c5.76,0,9.6,2.72,9.6,7.16,0,3.6-3,5.68-5.76,6.12C38.44,47.5,42.08,49.58,42.08,53.7Zm24.36-1.16c0,4.92-3.88,9-9.84,9-7.84,0-11-6.36-11-13.8,0-7.68,4-13.76,11.76-13.76a10.48,10.48,0,0,1,7.64,3l-2.16,3.52a7,7,0,0,0-5.48-2.32c-4.48,0-7,4.12-7,8.8v.76a9.25,9.25,0,0,1,7.16-3.76C62.28,43.9,66.44,46.86,66.44,52.54Zm-4.76.16c0-3.28-2.56-4.76-5.44-4.76a7.21,7.21,0,0,0-5.84,3.12c.24,2.88,1.84,6.28,5.92,6.28C59.84,57.34,61.68,54.82,61.68,52.7ZM91,47.7c0,6.68-3.16,13.8-10.64,13.8S69.64,54.38,69.64,47.7,72.8,33.94,80.32,33.94,91,41,91,47.7Zm-4.76,0c0-5.12-1.52-9.6-5.88-9.6s-5.92,4.48-5.92,9.6,1.56,9.64,5.92,9.64S86.2,52.78,86.2,47.7Zm19-12a6.74,6.74,0,1,1-6.76-6.6A6.45,6.45,0,0,1,105.2,35.7Zm-3.16,0c0-2.4-1.32-4-3.6-4S95,33.3,95,35.7s1.28,4.08,3.48,4.08S102,38.06,102,35.7Z"
        />
        <path
          data-name="vr-icon-arrows"
          d="M60,82.5a155,155,0,0,1-17-.91c3,19.8,9.8,33.41,17,33.41,5,0,10-6.73,13.53-18.12L68.69,95.7l9.63-10.1L82.26,99l-4.84-1.17C73.19,111.49,67,119,60,119c-9.62,0-17.82-14.84-21.07-37.93C16.55,77.9,1,69.77,1,60c0-3.08,1.44-6,4.29-8.7L2.68,47l14-.29L9.91,58.93l-2.48-4.1A7.64,7.64,0,0,0,5,60c0,8.93,22.1,18.5,55,18.5s55-9.57,55-18.5c0-3.34-3.18-6.83-9-9.85l-1.78-.92,1.85-3.55,1.78.93C115.16,50.4,119,55,119,60,119,72.62,93.08,82.5,60,82.5ZM60,5c5.36,0,10.9,8.14,14.45,21.24l3.86-1C74.14,9.82,67.47,1,60,1S45.86,9.82,41.69,25.2l3.86,1C49.1,13.14,54.64,5,60,5Z"
        />
      </g>
    </svg>
  );
};

export default VrIcon;
